<template>
  <div class="signin--page">
    <van-nav-bar title="签到领积分" left-text="返回" left-arrow fixed @click-left="goBack"></van-nav-bar>
    <div class="da-box">
      <img v-for="ad in adList" :src="ad.CoverImage" :alt="ad.Title" :key="ad.Id" />
    </div>
    <div class="score_box">
      <p class="gray_msg">我的买道积分</p>
      <p class="score_count">{{ scoreCount }}</p>
      <p>
        <van-button v-if="!isTodayDid" type="primary" class="md_middle_btn" size="small" round @click="signin"
          >立即签到</van-button
        >
        <van-button v-else :disabled="true" class="md_middle_btn" size="small" round>今日已签到</van-button>
      </p>
    </div>
    <div class="line"></div>
    <mdScroll class="w score_log_list" ref="mescroll" listAlias="ScoreLogs" :url="url" :filterData="queryData" @getList="getScoreLogList" @getResult="getResult">
      <div class="score_log" v-for="score in scoreList" :key="score.Id">
        <div class="content">
          <p>{{ score.Behavior | score-behavior }}</p>
          <p class="gray_msg">{{ score.CreateTime | datetime-parse }}</p>
        </div>
        <div class="count" :class="{'text-red': score.InScore}">{{ getScoreSign(score.InScore, score.Behavior)  }}</div>
      </div>
    </mdScroll>
  </div>
</template>
<script>
import commonMix from '@/mixins/commonMix'
import AdManager from '@/mixins/adManager'
import {Account} from '@/api'
import mdScroll from "@/components/mdScroll/mdScroll";
export default {
  name: 'Singin',
  mixins: [commonMix, AdManager],
  components: {mdScroll},
  data() {
    return {
      Id: this.$mdUtils.getUserInfo('Id'),
      url: Account.GetScoreLogsByPage,
      adFilterData: {
        PositionName: 'cms-signin-top',
        WebsiteId: null,
        AdNum: 1
      },
      scoreCount: 0,
      scoreList: [],
      isTodayDid: false,
      queryData: {
        Owner: this.$mdUtils.getUserInfo('Id'),
        PageIndex: 1,
        PageSize: 10
      },
      oList: []
    }
  },
  created() {
    this.getAdData()
    this.TodayDidCheckIn()
  },
  methods: {
    getScoreLogList(list) {
      this.scoreList = list
    },
    getResult(result) {
      this.scoreCount = result.AvailableScore
    },
    TodayDidCheckIn() {
      return this.$api(Account.TodayDidCheckIn, {Id: this.Id}).then(res => {
        this.isTodayDid = res
      })
    },
    signin() {
      this.$api(Account.CheckIn, {Id: this.Id}).then(() => {
        this.isTodayDid = true
        this.$refs.mescroll.getList();
      })
    },
    getScoreSign(scoreNum, scoreStatus) {
      scoreNum = Math.abs(scoreNum)
      if (scoreStatus === 1 << 3 || scoreStatus === 1 << 14 || scoreStatus === 1 << 9 || scoreStatus === 1 << 11) {
        return '-' + scoreNum  
      } else {
        return '+' +  scoreNum 
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.signin--page {
  position: relative;
  padding-top: 46px;
}

.da-box {
  img {
    width: 100%;
    height: 150px;
  }
}

.score_box {
  margin-top: 12px;
  text-align: center;
  * {
    margin: 0;
  }
  .score_count {
    font-size: 42px;
    color: $red;
    line-height: 76px;
  }
}

.gray_msg {
  color: $gray-deep;
  font-size: 12px;
}

.md_middle_btn {
  width: 148px;
}
.line {
  margin-top: 12px;
  height: 5px;
  background: #f2f2f2;
  width: 100%;
}

.score_log_list {
  top: 352px;
  * {
    margin: 0;
  }

  .score_log {
    display: flex;
    line-height: 74px;
    padding: 0 22px;
    border-bottom: 1px solid $gray;

    .content {
      flex: 1;
      font-size: 16px;
      line-height: 22px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .count {
      width: 100px;
      text-align: right;
    }
  }
}
</style>
